module.exports = __webpack_public_path__ + "media/media/success/warranty-9b2376d3da989a18dda9309c1cc2a7dd.png";